import { IntegrateSidebarActions } from "@rapid/components/flow/shared/Deploy/IntegrateSidebarActions";
import { IntegrateSideMenu } from "@rapid/components/flow/shared/Deploy/IntegrateSideMenu";
import { SidebarHeader } from "@rapid/components/layout/SidebarHeader";
import { BuildSteps, Flows } from "@rapid/types/flows";

export const PreviewSidebarContent = () => {
    return (
        <>
            <SidebarHeader title="How do you want to use your model?" />
            <IntegrateSideMenu />
            <IntegrateSidebarActions previousFlow={Flows.BUILD} previousStep={BuildSteps.REVIEW} />
        </>
    );
};
